module.exports = "/_next/static/images/8b3da45034d5170e464f2554b91eef34-sanpablo-5.jpg.webp";